﻿import {IAuthenticationService} from './authentication.service';

export class AuthenticationHttpInterceptor implements angular.IHttpInterceptor {
    public static factory($q: ng.IQService, authenticationService: IAuthenticationService): AuthenticationHttpInterceptor {
        return new AuthenticationHttpInterceptor($q, authenticationService);
    }
    
    static $inject = [ '$q', 'authenticationService'];
    constructor(
        private $q: ng.IQService,
        private authenticationService: IAuthenticationService) { }

    public request = (config: ng.IRequestConfig): ng.IRequestConfig => {

        let accessToken = this.authenticationService.getAccessToken();

        if (accessToken != undefined) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    }

    public response = (response: ng.IHttpPromiseCallbackArg<any>): ng.IPromise<any> => {
        const provisionalAccessToken: string = response.headers('Idi-Refresh-Token');
        if (provisionalAccessToken) {
            this.authenticationService.setAccessToken(provisionalAccessToken);
        }

        return this.$q.when(response);
    }
}

AuthenticationHttpInterceptor.factory.$inject = ['$q', 'authenticationService'];